import { getHasuraApiUrl } from '@fourthwall/env';
import { ApiBase } from '../ApiBase';
class HasuraApiClientModel extends ApiBase {
    constructor() {
        super(...arguments);
        this.getMailingListReport = (shopId) => {
            return this.get(`/rest/reports/mailing-list/${shopId}`);
        };
        this.getContributionsSubscriptions = (params) => this.post('/rest/admin/dashboard/contributions/subscriptions', params);
        this.getContributionsSubscription = (billingId) => this.get(`/rest/admin/dashboard/contributions/subscriptions/${billingId}`);
        this.getUserLifecycleIntent = (requestBody) => {
            return this.post('/rest/user-life-cycle-intent-required-data', {
                shopId: requestBody.shopId,
                offersCreatedAfter: requestBody.offersCreatedAfter,
                sampleOrdersCreatedAfter: requestBody.sampleOrdersCreatedAfter,
            });
        };
    }
}
export const HasuraApiClient = new HasuraApiClientModel(getHasuraApiUrl('api'));
